import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { RehireDispatcherInterface } from '../../../models/dashboard/driver-lookup/rehire-dispatcher';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useRehireDriver = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onRehireDriverError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(err?.response?.data?.message || 'An error occurred while fetching rating data.');
    };

    const onRehireDriverSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        callbackFn();
        toast.success(message || 'Driver has been rehired successfully.');
    };

    const rehireDriver = (data: RehireDispatcherInterface, callbackFn: () => void) => {
        const formData = new FormData();
        formData.append('employmentType', data.employmentType);
        formData.append('startDate', data.startDate);
        formData.append('phoneNumber', data.phoneNumber);
        formData.append('address', data.address);
        formData.append('driverId', data.driverId || '');
        if (data.profilePicture && data.profilePicture.length > 0) {
            formData.append('profilePicture', data.profilePicture[0]);
        }

        const url: HttpConfig = {
            url: 'api/v1/dispatchers/re-hire',
            method: 'post',
            data: formData,

        };
        request(url, onRehireDriverSuccess(callbackFn), setLoading, onRehireDriverError);
    };

    return { rehireDriver, loading };
};

export default useRehireDriver;

